import { container } from "tsyringe";
import "reflect-metadata";
import { BusinessPartnerClient } from "./businessPartnersClient";
import { ResultDto } from "../../generated-client";

export class BusinessPartnerService {
	private readonly businessPartnerClient: BusinessPartnerClient =
		container.resolve(BusinessPartnerClient);

	public async getBusinessPartners(): Promise<ResultDto> {
		return await this.businessPartnerClient.businessPartnersApi.businessPartnersControllerGetBusinessPartners();
	}

	public async getBusinessPartner(cardCode: string): Promise<ResultDto> {
		return await this.businessPartnerClient.businessPartnersApi.businessPartnersControllerGetBusinessPartner(
			{ cardCode },
		);
	}
}
